/* Preet homepage scripts - fail-safe build.
   Reveals run FIRST so content is never stuck invisible; features are
   isolated; a safety timer force-shows anything still hidden after 4s. */

// Scroll reveals (before anything that could fail)
try {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => io.observe(el));
} catch (e) {
  console.error('Preet reveals failed, force-showing content:', e);
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function (el) {
    el.classList.add('in'); el.style.opacity = '1'; el.style.transform = 'none';
  });
}

// Safety net: never leave content invisible, whatever else happens
setTimeout(function () {
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function (el) {
    if (getComputedStyle(el).opacity === '0') { el.classList.add('in'); el.style.opacity = '1'; el.style.transform = 'none'; }
  });
}, 4000);

// Hero, marquee, shelf, signup
try {
// Slideshow
const slides = document.querySelectorAll('.hero-slide');
const dots   = document.querySelectorAll('.hero-dot');
let cur = 0, timer;
function goTo(n) {
  slides[cur].classList.remove('active');
  dots[cur].classList.remove('active');
  cur = (n + slides.length) % slides.length;
  slides[cur].classList.add('active');
  dots[cur].classList.add('active');
}
timer = setInterval(() => goTo(cur + 1), 5500);
dots.forEach(d => d.addEventListener('click', () => {
  clearInterval(timer);
  goTo(parseInt(d.dataset.slide));
  timer = setInterval(() => goTo(cur + 1), 5500);
}));


/* ===== Interactive cherry-wood shelf ===== */
(function(){
  const shelfDataEl = document.querySelector('[data-shelf-bottles]');
  const shelfSection = shelfDataEl ? shelfDataEl.closest('.shelf-section') : null;
  let SHELF = [];
  try { SHELF = shelfDataEl ? JSON.parse(shelfDataEl.textContent) : []; }
  catch (e) { console.error('Preet shelf data could not be read:', e); }

  /* Real-size bottle scale. Each bottle supplies its physical height and width
     in inches. The section converts those dimensions to one shared pixel scale,
     so short, tall, narrow and wide bottles remain proportional to one another. */
  var sizeConfig = {
    pxPerInch: parseFloat(shelfSection && shelfSection.dataset.shelfScale) || 52,
    minHeight: parseFloat(shelfSection && shelfSection.dataset.shelfMinHeight) || 420,
    maxHeight: parseFloat(shelfSection && shelfSection.dataset.shelfMaxHeight) || 680,
    mobileScale: (parseFloat(shelfSection && shelfSection.dataset.shelfMobileScale) || 72) / 100,
    gap: parseFloat(shelfSection && shelfSection.dataset.shelfGap) || 72,
    whiteThreshold: parseFloat(shelfSection && shelfSection.dataset.whiteThreshold) || 220,
    depthOpacity: parseFloat(shelfSection && getComputedStyle(shelfSection).getPropertyValue('--shelf-depth-opacity')) || 0.28,
    rimOpacity: parseFloat(shelfSection && getComputedStyle(shelfSection).getPropertyValue('--shelf-rim-opacity')) || 0.075,
    contactOpacity: parseFloat(shelfSection && getComputedStyle(shelfSection).getPropertyValue('--shelf-contact-opacity')) || 0.60
  };

  function clampShelfNumber(value, min, max){
    return Math.min(max, Math.max(min, value));
  }

  function bottleDisplaySize(b){
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var responsiveScale = mobile ? sizeConfig.mobileScale : 1;
    var correction = (parseFloat(b.visualScale) || 100) / 100;
    var displayScale = (parseFloat(b.displayScale) || 100) / 100;
    var perBottleMobileScale = mobile ? ((parseFloat(b.mobileDisplayScale) || 100) / 100) : 1;
    var physicalHeight = parseFloat(b.realHeight) || 12.5;
    var physicalWidth = parseFloat(b.realWidth) || 3.5;
    var pxScale = sizeConfig.pxPerInch * responsiveScale * correction;
    var height = physicalHeight * pxScale;
    var width = physicalWidth * pxScale;
    var minHeight = sizeConfig.minHeight * responsiveScale;
    var maxHeight = sizeConfig.maxHeight * responsiveScale;

    if(height < minHeight){
      var grow = minHeight / height;
      height = minHeight;
      width *= grow;
    }
    if(height > maxHeight){
      var shrink = maxHeight / height;
      height = maxHeight;
      width *= shrink;
    }

    /* Prevent an unusually wide decanter from breaking the shelf while keeping
       its height/width ratio intact. */
    var maxWidth = mobile ? 210 : 320;
    if(width > maxWidth){
      var widthScale = maxWidth / width;
      width = maxWidth;
      height *= widthScale;
    }

    /* Per-card Theme Editor controls. Display scale preserves the bottle's
       proportions. Exact desktop height/width overrides are optional and use
       zero as the automatic setting. */
    height *= displayScale * perBottleMobileScale;
    width *= displayScale * perBottleMobileScale;

    if(!mobile){
      var exactHeight = parseFloat(b.desktopHeightOverride) || 0;
      var exactWidth = parseFloat(b.desktopWidthOverride) || 0;
      var currentRatio = width > 0 ? height / width : 1;

      if(exactHeight > 0 && exactWidth > 0){
        height = exactHeight;
        width = exactWidth;
      } else if(exactHeight > 0){
        height = exactHeight;
        width = exactHeight / currentRatio;
      } else if(exactWidth > 0){
        width = exactWidth;
        height = exactWidth * currentRatio;
      }
    }

    width = Math.max(mobile ? 52 : 64, width);
    /* Automatic bottles use the large section minimum above. Keep this final
       guard modest so an intentional per-bottle exact-height override can
       still make an individual bottle smaller when needed. */
    height = Math.max(mobile ? 120 : 160, height);
    var slotWidth = Math.max(mobile ? 230 : 290, width + (sizeConfig.gap * responsiveScale));
    var shadowWidth = b.autoShadow === false
      ? (parseFloat(b.bw) || 72) * responsiveScale
      : clampShelfNumber(width * 0.9, mobile ? 70 : 88, mobile ? 190 : 270);

    return {
      height: Math.round(height * 10) / 10,
      width: Math.round(width * 10) / 10,
      slotWidth: Math.round(slotWidth * 10) / 10,
      shadowWidth: Math.round(shadowWidth * 10) / 10,
      offset: ((parseFloat(b.verticalOffset) || 0) + (parseFloat(b.contactAdjustment) || 0)) * responsiveScale
    };
  }

  function applyBottleSize(slot, b){
    var size = bottleDisplaySize(b);
    slot.style.setProperty('--bottle-h', size.height + 'px');
    slot.style.setProperty('--bottle-w', size.width + 'px');
    slot.style.setProperty('--slot-w', size.slotWidth + 'px');
    slot.style.setProperty('--shadow-w', size.shadowWidth + 'px');
    slot.style.setProperty('--active-shadow-w', (size.shadowWidth * 1.08) + 'px');
    slot.style.setProperty('--bottle-offset', size.offset + 'px');
    var depthFactor = (parseFloat(b.depthIntensity) || 100) / 100;
    slot.style.setProperty('--depth-factor', depthFactor);
    slot.style.setProperty('--bottle-depth-opacity', clampShelfNumber(sizeConfig.depthOpacity * depthFactor, 0, 0.72));
    slot.style.setProperty('--bottle-depth-active-opacity', clampShelfNumber((sizeConfig.depthOpacity * depthFactor) + 0.08, 0, 0.82));
    slot.style.setProperty('--bottle-rim-opacity', clampShelfNumber(sizeConfig.rimOpacity * depthFactor, 0, 0.32));
    slot.style.setProperty('--bottle-contact-opacity', clampShelfNumber(sizeConfig.contactOpacity * depthFactor, 0, 0.92));
    slot.style.setProperty('--bottle-contact-core-opacity', clampShelfNumber(0.62 * depthFactor, 0.28, 0.9));
  }


  /* Remove light, neutral pixels only when they connect to an outside edge.
     This clears white product-photo backgrounds without erasing enclosed white
     labels, foil details or highlights inside the bottle silhouette. */
  function removeConnectedWhiteBackground(imageData, width, height, threshold){
    var data=imageData.data,total=width*height;
    var visited=new Uint8Array(total),queue=new Int32Array(total),head=0,tail=0;
    function candidate(index){
      var p=index*4;
      if(data[p+3]===0)return false;
      var r=data[p],g=data[p+1],b=data[p+2];
      var high=Math.max(r,g,b),low=Math.min(r,g,b),lum=(r+g+b)/3;
      return lum>=threshold-16&&(high-low)<=46;
    }
    function add(index){
      if(index<0||index>=total||visited[index]||!candidate(index))return;
      visited[index]=1;queue[tail++]=index;
    }
    for(var x=0;x<width;x++){add(x);add((height-1)*width+x);}
    for(var y=0;y<height;y++){add(y*width);add(y*width+width-1);}
    if(tail<Math.max(4,Math.round((width+height)*.02)))return false;
    while(head<tail){
      var index=queue[head++],xp=index%width,yp=(index-xp)/width;
      if(xp>0)add(index-1);if(xp<width-1)add(index+1);
      if(yp>0)add(index-width);if(yp<height-1)add(index+width);
    }
    for(var i=0;i<tail;i++){
      var px=queue[i]*4,lum=(data[px]+data[px+1]+data[px+2])/3;
      var removal=clampShelfNumber((lum-(threshold-18))/38,0,1);
      data[px+3]=Math.round(data[px+3]*(1-removal));
    }
    return true;
  }

  function cropBottleCanvas(source){
    var ctx=source.getContext('2d',{willReadFrequently:true});
    var w=source.width,h=source.height,pixels=ctx.getImageData(0,0,w,h).data;
    var left=w,right=-1,top=h,bottom=-1;

    /* First find the visible alpha bounds after background cleanup. */
    for(var y=0;y<h;y++)for(var x=0;x<w;x++){
      if(pixels[(y*w+x)*4+3]>18){
        if(x<left)left=x;if(x>right)right=x;if(y<top)top=y;if(y>bottom)bottom=y;
      }
    }
    if(right<left||bottom<top)return source;

    /* Product photos often contain a faint built-in floor shadow or reflection.
       Find the last row with genuinely opaque bottle pixels, then trim away the
       low-alpha material below it. This makes the visible bottle—not its image
       canvas—land directly on the shelf. */
    var contentWidth=right-left+1;
    var minimumStrong=Math.max(2,Math.round(contentWidth*.008));
    var strongBottom=-1;
    for(var row=bottom;row>=top;row--){
      var strong=0;
      for(var col=left;col<=right;col++){
        if(pixels[(row*w+col)*4+3]>=120)strong++;
      }
      if(strong>=minimumStrong){strongBottom=row;break;}
    }
    if(strongBottom<0){
      for(var row2=bottom;row2>=top;row2--){
        var medium=0;
        for(var col2=left;col2<=right;col2++){
          if(pixels[(row2*w+col2)*4+3]>=58)medium++;
        }
        if(medium>=minimumStrong){strongBottom=row2;break;}
      }
    }
    if(strongBottom>=0){
      var bottomSafety=Math.max(1,Math.round(h*.0035));
      bottom=Math.min(bottom,strongBottom+bottomSafety);
    }

    /* Preserve a little breathing room on the top and sides, but deliberately
       add no padding below the bottle. The final opaque bottle row therefore
       sits on the bottom edge of the normalized PNG. */
    var sidePad=Math.max(2,Math.round(Math.max(w,h)*.006));
    var topPad=Math.max(2,Math.round(Math.max(w,h)*.006));
    left=Math.max(0,left-sidePad);top=Math.max(0,top-topPad);
    right=Math.min(w-1,right+sidePad);bottom=Math.min(h-1,bottom);

    var sourceWidth=right-left+1,sourceHeight=bottom-top+1;
    var cropped=document.createElement('canvas');
    cropped.width=sourceWidth;
    cropped.height=sourceHeight;
    cropped.getContext('2d').drawImage(
      source,left,top,sourceWidth,sourceHeight,
      0,0,sourceWidth,sourceHeight
    );
    return cropped;
  }

  function normalizeBottleImage(img,b,depthImg){
    if(!b.img)return;
    var source=new Image();source.crossOrigin='anonymous';source.decoding='async';
    source.onload=function(){
      try{
        var nw=source.naturalWidth||source.width,nh=source.naturalHeight||source.height;
        if(!nw||!nh)return;
        var ratio=Math.min(1,1400/Math.max(nw,nh));
        var canvas=document.createElement('canvas');
        canvas.width=Math.max(1,Math.round(nw*ratio));canvas.height=Math.max(1,Math.round(nh*ratio));
        var ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(source,0,0,canvas.width,canvas.height);
        if(b.removeWhite!==false){
          var pixels=ctx.getImageData(0,0,canvas.width,canvas.height);
          if(removeConnectedWhiteBackground(pixels,canvas.width,canvas.height,sizeConfig.whiteThreshold))ctx.putImageData(pixels,0,0);
        }
        var normalized=cropBottleCanvas(canvas);
        var normalizedSource=normalized.toDataURL('image/png');
        img.src=normalizedSource;
        img.classList.add('shf-photo--processed');
        img.dataset.shelfGrounded='true';
        if(depthImg){
          depthImg.src=normalizedSource;
          depthImg.classList.add('shf-depth-copy--processed');
        }
      }catch(error){
        img.classList.add('shf-photo--cleanup-fallback');
        if(depthImg)depthImg.classList.add('shf-depth-copy--fallback');
        console.warn('Bottle background cleanup used the visual fallback.',error);
      }
    };
    source.onerror=function(){
      img.classList.add('shf-photo--cleanup-fallback');
      if(depthImg)depthImg.classList.add('shf-depth-copy--fallback');
    };
    source.src=b.img;
  }

  function capMark(b){
    if(b.crystal){
      return '<g>'
        +'<path d="M58,-6 L70,-6 L67,3 L61,3 Z" fill="'+b.cap+'"/>'
        +'<rect x="56" y="2" width="16" height="9" rx="3" fill="'+b.cap+'"/>'
        +'<rect x="52" y="11" width="24" height="8" rx="2" fill="'+b.cap+'"/>'
        +'<rect x="52" y="14" width="24" height="2" fill="rgba(0,0,0,.25)"/>'
        +'</g>';
    }
    var band=(b.cork||b.premium)
      ? '<rect x="52" y="29" width="24" height="3" fill="#caa15a" opacity=".9"/>'
      : '<rect x="52" y="28" width="24" height="4" fill="rgba(0,0,0,.32)"/>';
    return '<g>'
      +'<rect x="52" y="5" width="24" height="27" rx="3" fill="'+b.cap+'"/>'
      +'<rect x="55" y="8" width="5" height="20" rx="2.5" fill="rgba(255,255,255,.16)"/>'
      +band+'</g>';
  }

  function buildBottle(b){
    var bodyBot=283;
    var liqTop=Math.round(bodyBot-b.level*(bodyBot-140));
    var L=b.labelLines, ink=b.ink, label;
    if(L.length===1){
      label='<text x="64" y="221" font-family="Playfair Display,Georgia,serif" font-size="11" letter-spacing="1.4" text-anchor="middle" fill="'+ink+'">'+L[0]+'</text>'
        +'<rect x="40" y="231" width="48" height="1" fill="'+ink+'" opacity=".55"/>'
        +'<text x="64" y="248" font-family="Jost,sans-serif" font-size="5.4" letter-spacing="1.1" text-anchor="middle" fill="'+ink+'" opacity=".82">'+b.tag+'</text>';
    } else {
      label='<text x="64" y="216" font-family="Playfair Display,Georgia,serif" font-size="10" letter-spacing="1.2" text-anchor="middle" fill="'+ink+'">'+L[0]+'</text>'
        +'<text x="64" y="229" font-family="Playfair Display,Georgia,serif" font-size="10" letter-spacing="1.2" text-anchor="middle" fill="'+ink+'">'+L[1]+'</text>'
        +'<rect x="40" y="238" width="48" height="1" fill="'+ink+'" opacity=".55"/>'
        +'<text x="64" y="252" font-family="Jost,sans-serif" font-size="5.1" letter-spacing="1" text-anchor="middle" fill="'+ink+'" opacity=".82">'+b.tag+'</text>';
    }
    var medal=b.premium
      ? '<circle cx="64" cy="106" r="8" fill="#e8b86d" stroke="#5a3d18" stroke-width="1"/><text x="64" y="109.4" font-size="9" text-anchor="middle" fill="#3a2410" font-family="serif">&#9733;</text>'
      : '';
    return '<svg viewBox="0 0 128 300" xmlns="http://www.w3.org/2000/svg">'
      +'<rect x="55" y="22" width="18" height="64" fill="'+b.glass+'"/>'
      +'<path d="M55,82 C49,98 30,100 27,124 L27,278 Q27,289 38,289 L90,289 Q101,289 101,278 L101,124 C98,100 79,98 73,82 Z" fill="'+b.glass+'"/>'
      +'<path d="M31,'+liqTop+' L31,276 Q31,283 38,283 L90,283 Q97,283 97,276 L97,'+liqTop+' Z" fill="'+b.liquid+'"/>'
      +'<ellipse cx="64" cy="'+liqTop+'" rx="33" ry="3.5" fill="rgba(255,255,255,.12)"/>'
      +'<path d="M31,262 L97,262 L97,276 Q97,283 90,283 L38,283 Q31,283 31,276 Z" fill="rgba(0,0,0,.16)"/>'
      +'<path d="M33,126 C31,162 31,216 33,272 L40,272 C38,216 38,162 40,126 Z" fill="rgba(255,255,255,.14)"/>'
      +'<rect x="36" y="130" width="2.4" height="138" rx="1.2" fill="rgba(255,255,255,.22)"/>'
      +'<path d="M95,126 C97,162 97,216 95,272 L88,272 C90,216 90,162 88,126 Z" fill="rgba(0,0,0,.22)"/>'
      +'<ellipse cx="58" cy="96" rx="14" ry="6" fill="rgba(255,255,255,.10)"/>'
      +medal+capMark(b)
      +'<rect x="30" y="198" width="68" height="62" rx="3" fill="'+b.accent+'" stroke="rgba(232,184,109,.32)" stroke-width=".8"/>'
      +label+'</svg>';
  }

  var track=document.getElementById('shfTrack');
  if(!track)return;
  var toast=document.getElementById('shfToast'),tT;
  function showToast(name){toast.innerHTML='<b>'+name+'</b> added to cart';toast.classList.add('show');clearTimeout(tT);tT=setTimeout(function(){toast.classList.remove('show');},2200);}

  var pop=document.getElementById('shfPop'),
      card=document.getElementById('shfCard'),
      ptr=document.getElementById('shfPtr'),
      wrap=document.querySelector('.shf-wrap'),
      scroll=document.getElementById('shfScroll'),
      slots=[],active=null,down=false,sx=0,sl=0;

  function cardHTML(b){
    var stk=b.status==='in'?'<span class="shf-stk in">In Stock</span>':'<span class="shf-stk low">Few Left</span>';
    var action=b.url?'<a class="shf-cart" href="'+b.url+'">View bottle details</a>':'<span class="shf-cart shf-cart--disabled">Ask in store</span>';
    return '<div class="shf-eye">'+b.eyebrow+'</div>'
      +'<div class="shf-name">'+b.name+'</div>'
      +'<div class="shf-note">'+b.note+'</div>'
      +'<div class="shf-meta">'+b.meta+'</div>'
      +'<div class="shf-row2"><span class="shf-price">'+b.price+'</span>'+stk+'</div>'
      +action;
  }

  function place(slot){
    var wr=wrap.getBoundingClientRect();
    var br=slot.querySelector('.shf-bottle').getBoundingClientRect();
    var pw=pop.offsetWidth,ph=pop.offsetHeight,pad=8;
    var bx=br.left+br.width/2-wr.left;
    var bty=br.top-wr.top;
    var left=Math.max(pad,Math.min(bx-pw/2,wr.width-pw-pad));
    var top=Math.max(pad,bty-ph-15);
    pop.style.left=left+'px';
    pop.style.top=top+'px';
    var px=Math.max(16,Math.min(bx-left,pw-16));
    ptr.style.left=px+'px';
  }

  function openPop(slot){
    var b=SHELF[+slot.dataset.i];
    if(active!==slot){
      slots.forEach(function(s){s.classList.remove('is-active');});
      slot.classList.add('is-active');
      track.classList.add('dimming');
      active=slot;
      card.innerHTML=cardHTML(b);
      var btn=card.querySelector('.shf-cart');
      if(btn&&btn.tagName==='A')btn.addEventListener('click',function(e){e.stopPropagation();});
    }
    pop.classList.add('is-on');
    place(slot);
  }
  function closePop(){
    pop.classList.remove('is-on');
    track.classList.remove('dimming');
    if(active){active.classList.remove('is-active');active.classList.remove('is-open');active=null;}
  }

  SHELF.forEach(function(b,i){
    var slot=document.createElement(b.url ? 'a' : 'div');
    slot.className='shf-slot';slot.dataset.i=i;
    if(b.url){
      slot.href=b.url;
      slot.setAttribute('data-preet-navigate','product');
      slot.setAttribute('aria-label','View '+(b.name||'bottle')+' details');
    }
    slot.style.setProperty('--glow', b.glow || 'rgba(232,184,109,.45)');
    applyBottleSize(slot, b);

    var bottleWrap=document.createElement('div');bottleWrap.className='shf-bottle';
    var aura=document.createElement('span');aura.className='shf-depth-aura';aura.setAttribute('aria-hidden','true');
    var depthImage=document.createElement('img');
    depthImage.className='shf-depth-copy';depthImage.src=b.img||'';depthImage.alt='';depthImage.draggable=false;depthImage.setAttribute('aria-hidden','true');
    var image=document.createElement('img');
    image.className='shf-photo preet-product-image preet-image--'+(b.mode||'blend');
    image.src=b.img||'';image.alt=b.name||'';image.draggable=false;
    bottleWrap.appendChild(aura);bottleWrap.appendChild(depthImage);bottleWrap.appendChild(image);
    var base=document.createElement('div');base.className='shf-base';base.setAttribute('aria-hidden','true');
    slot.appendChild(bottleWrap);slot.appendChild(base);
    track.appendChild(slot);slots.push(slot);
    normalizeBottleImage(image,b,depthImage);

    slot.addEventListener('click',function(e){
      if(track.dataset.dragged==='1'){
        if(b.url)e.preventDefault();
        return;
      }

      /* Mobile shelf interaction: the first tap reveals the bottle information;
         tapping the same bottle again follows its existing product link. Desktop
         links keep their current one-click behavior. */
      var mobileShelfTap=window.matchMedia('(max-width: 749px)').matches;
      if(b.url&&mobileShelfTap){
        var alreadyOpen=active===slot&&slot.classList.contains('is-open');
        if(alreadyOpen)return;
        e.preventDefault();
        slots.forEach(function(s){s.classList.remove('is-open');});
        slot.classList.add('is-open');
        openPop(slot);
        return;
      }

      if(b.url)return;
      var pinned=slot.classList.contains('is-open');
      slots.forEach(function(s){s.classList.remove('is-open');});
      if(pinned){closePop();}else{slot.classList.add('is-open');openPop(slot);}
    });
  });

  /* plank paints in front of the bottles so they sit behind the shelf's front edge */
  var _plk=track.querySelector('.shf-plank'); if(_plk){track.appendChild(_plk);}

  /* hover (mouse/pen): only the bottle itself triggers; popup persists while you move to it */
  track.addEventListener('pointermove',function(e){
    if(e.pointerType==='touch'||down)return;
    var bot=e.target.closest&&e.target.closest('.shf-bottle');
    if(bot&&bot.parentNode!==active)openPop(bot.parentNode);
  });
  wrap.addEventListener('pointerleave',function(e){
    if(e.pointerType==='touch')return;
    if(!(active&&active.classList.contains('is-open')))closePop();
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('.shf-slot')&&!e.target.closest('.shf-pop'))closePop();
  });

  /* arrows */
  var aL=document.getElementById('shfL'),aR=document.getElementById('shfR');
  function step(){return Math.max(240,scroll.clientWidth*0.7);}
  aL.addEventListener('click',function(){scroll.scrollBy({left:-step(),behavior:'smooth'});});
  aR.addEventListener('click',function(){scroll.scrollBy({left:step(),behavior:'smooth'});});
  function syncArrows(){
    var max=scroll.scrollWidth-scroll.clientWidth-2;
    aL.classList.toggle('off',scroll.scrollLeft<=2);
    aR.classList.toggle('off',scroll.scrollLeft>=max);
  }
  function resizeShelfBottles(){
    slots.forEach(function(slot){
      var b = SHELF[+slot.dataset.i];
      if(b) applyBottleSize(slot, b);
    });
  }
  scroll.addEventListener('scroll',function(){syncArrows();closePop();});
  window.addEventListener('resize',function(){resizeShelfBottles();syncArrows();closePop();});
  setTimeout(function(){resizeShelfBottles();syncArrows();},60);

  /* drag to scroll (mouse/pen) */
  scroll.addEventListener('pointerdown',function(e){
    if(e.pointerType==='touch')return;
    down=true;sx=e.clientX;sl=scroll.scrollLeft;scroll.classList.add('is-grab');track.dataset.dragged='0';closePop();
  });
  scroll.addEventListener('pointermove',function(e){
    if(!down)return;
    var dx=e.clientX-sx;scroll.scrollLeft=sl-dx;
    if(Math.abs(dx)>6)track.dataset.dragged='1';
    e.preventDefault();
  });
  function endDrag(){if(!down)return;down=false;scroll.classList.remove('is-grab');setTimeout(function(){track.dataset.dragged='0';},40);}
  scroll.addEventListener('pointerup',endDrag);
  scroll.addEventListener('pointerleave',endDrag);
})();
} catch (e) { console.error('Preet homepage features error:', e); }

// Header drawer, search, footer accordions, editor reload
try {
/* ---------- Header: drawer, search bar, footer accordions ---------- */
(function () {
  const body = document.body;
  const opener = document.querySelector('[data-drawer-open]');
  if (opener) opener.addEventListener('click', () => body.classList.add('drawer-open'));
  document.querySelectorAll('[data-drawer-close]').forEach(c =>
    c.addEventListener('click', () => body.classList.remove('drawer-open')));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') body.classList.remove('drawer-open'); });
  document.querySelectorAll('[data-drawer-acc]').forEach(btn =>
    btn.addEventListener('click', () => btn.closest('.drawer-item').classList.toggle('open')));
  const st = document.querySelector('[data-search-toggle]');
  const sb = document.getElementById('preetSearchBar');
  if (st && sb) st.addEventListener('click', function (e) {
    e.preventDefault();
    sb.classList.toggle('open');
    if (sb.classList.contains('open')) { const i = sb.querySelector('input'); if (i) i.focus(); }
  });
  document.querySelectorAll('.footer-col .f-toggle').forEach(t =>
    t.addEventListener('click', () => t.closest('.footer-col').classList.toggle('open')));
})();


/* Theme editor: sections re-render without re-running scripts (shelf, hero,
   reveals would go blank). Reload the preview after any section edit.
   Runs ONLY inside the customizer; storefront is untouched. */
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    window.location.reload();
  });
}
} catch (e) { console.error('Preet header features error:', e); }


/* Horizontal Staff Picks / Product Showcase rails — Phase 4.4
   Supports arrows, trackpads, mouse dragging, and horizontal finger swiping. */
(function(){
  function initShowcaseRail(scope){
    (scope || document).querySelectorAll('[data-showcase-rail]').forEach(function(rail){
      if(rail.dataset.preetRailReady === '1') return;
      rail.dataset.preetRailReady = '1';

      var section = rail.closest('.showcase');
      if(!section) return;

      var prev = section.querySelector('[data-showcase-prev]');
      var next = section.querySelector('[data-showcase-next]');
      var pointerDown = false;
      var horizontalIntent = false;
      var dragged = false;
      var suppressClick = false;
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var activePointerId = null;

      function step(){
        var card = rail.querySelector('.product-card');
        if(!card) return Math.max(260, rail.clientWidth * .8);
        var styles = getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function sync(){
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
        var scrollable = max > 2;
        section.classList.toggle('showcase--scrollable', scrollable);
        rail.setAttribute('aria-roledescription', scrollable ? 'scrollable product carousel' : 'product list');
        if(prev) prev.disabled = !scrollable || rail.scrollLeft <= 2;
        if(next) next.disabled = !scrollable || rail.scrollLeft >= max;
      }

      function scrollByCard(direction){
        rail.scrollBy({ left: step() * direction, behavior: 'smooth' });
      }

      if(prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
      if(next) next.addEventListener('click', function(){ scrollByCard(1); });

      rail.addEventListener('scroll', sync, { passive: true });

      rail.addEventListener('keydown', function(e){
        if(e.key === 'ArrowLeft'){
          e.preventDefault();
          scrollByCard(-1);
        }
        if(e.key === 'ArrowRight'){
          e.preventDefault();
          scrollByCard(1);
        }
      });

      /* Prevent the browser's native image drag from fighting the rail drag. */
      rail.addEventListener('dragstart', function(e){
        if(e.target.closest('img, a')) e.preventDefault();
      });

      rail.addEventListener('pointerdown', function(e){
        if(e.pointerType === 'mouse' && e.button !== 0) return;

        /* Mobile uses the browser's native horizontal scrolling. This keeps
           vertical page scrolling natural while allowing a direct finger swipe
           across the product tiles. Desktop mouse dragging remains unchanged. */
        var mobileNativeSwipe = e.pointerType !== 'mouse' &&
          window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        if(mobileNativeSwipe) return;

        pointerDown = true;
        horizontalIntent = false;
        dragged = false;
        suppressClick = false;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = rail.scrollLeft;
        activePointerId = e.pointerId;
      });

      rail.addEventListener('pointermove', function(e){
        if(!pointerDown || e.pointerId !== activePointerId) return;

        var deltaX = e.clientX - startX;
        var deltaY = e.clientY - startY;

        if(!horizontalIntent){
          var dragThreshold = e.pointerType === 'mouse' ? 10 : 7;

          /* Keep normal page scrolling when a touch gesture is primarily vertical. */
          if(e.pointerType !== 'mouse' && Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > dragThreshold){
            pointerDown = false;
            activePointerId = null;
            return;
          }

          /* A link remains a normal click until the visitor makes a deliberate
             horizontal drag. This prevents Learn More clicks from being swallowed. */
          if(Math.abs(deltaX) > dragThreshold && Math.abs(deltaX) >= Math.abs(deltaY)){
            horizontalIntent = true;
            dragged = true;
            suppressClick = true;
            rail.classList.add('is-dragging');
            try { rail.setPointerCapture(e.pointerId); } catch(err) {}
          }
        }

        if(!horizontalIntent) return;

        rail.scrollLeft = startLeft - deltaX;
        e.preventDefault();
      });

      function endDrag(e){
        if(!pointerDown && !horizontalIntent) return;

        pointerDown = false;
        horizontalIntent = false;
        rail.classList.remove('is-dragging');

        if(activePointerId !== null){
          try { rail.releasePointerCapture(activePointerId); } catch(err) {}
        }
        activePointerId = null;

        /* Snap to the nearest card after a direct drag or swipe. */
        if(dragged){
          var cardStep = step();
          if(cardStep > 0){
            var destination = Math.round(rail.scrollLeft / cardStep) * cardStep;
            rail.scrollTo({ left: destination, behavior: 'smooth' });
          }
        }

        window.setTimeout(function(){
          dragged = false;
          suppressClick = false;
        }, 180);
      }

      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('lostpointercapture', function(e){
        if(e.pointerId === activePointerId) endDrag(e);
      });

      rail.addEventListener('click', function(e){
        if(suppressClick){
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      /* Trackpads keep their native horizontal movement. Shift + mouse wheel
         also moves the rail horizontally without requiring the arrows. */
      rail.addEventListener('wheel', function(e){
        var horizontalDelta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0;
        if(e.shiftKey && !horizontalDelta) horizontalDelta = e.deltaY;
        if(!horizontalDelta) return;

        var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var canMove = (horizontalDelta < 0 && rail.scrollLeft > 0) ||
                      (horizontalDelta > 0 && rail.scrollLeft < max);
        if(!canMove) return;

        rail.scrollLeft += horizontalDelta;
        e.preventDefault();
      }, { passive: false });

      if('ResizeObserver' in window){
        new ResizeObserver(sync).observe(rail);
      } else {
        window.addEventListener('resize', sync);
      }

      requestAnimationFrame(sync);
      setTimeout(sync, 250);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initShowcaseRail(document); });
  } else {
    initShowcaseRail(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    initShowcaseRail(e.target);
  });
})();
